module.exports = __webpack_public_path__ + "img/zambia.f3b5bcf9.svg";